import { FT5_VIEW_FEATURES_TRACKING, FT5_VIEW_TRACKING } from '../../constants';
import { TrackingDataExtractor } from './tracking-data-extractor';
import { TrackingHtmlConditionChecker } from './tracking-html-condition-checker';
import { getGlobalEventMergeId } from '../../_common/client/tracking';
import { TrackingFeatures } from './event-data-types';
import { eventQBus } from '@otto-ec/global-resources/event-q-bus';
import { DataContainer, submitEvent, submitEventMerge, submitMerge } from '@otto-ec/tracking-bct';
import { trackView as trackViewNexus } from '@otto-ec/nexus-registry/pdp/tracking';

const DATA_ATTRIBUTE_VIEW_TRACKING = 'data-ft5-view-tracking';

export class ViewTracking {
    constructor(
        private trackingDataExtractor: TrackingDataExtractor,
        private htmlConditionChecker: TrackingHtmlConditionChecker
    ) {}

    public registerViewTrackingFromCode(): void {
        eventQBus.on(FT5_VIEW_TRACKING, (trackingData: DataContainer) => {
            this.doTrackPageImpression(trackingData);
        });

        eventQBus.on(FT5_VIEW_FEATURES_TRACKING, (trackingData: TrackingFeatures) => {
            submitMerge({}, trackingData);
        });

        trackViewNexus.assignFunction(dataContainer => {
            this.doTrackPageImpression(dataContainer);
        });
    }

    public performHtmlViewTracking(): void {
        const viewTrackingTargets = document.querySelectorAll(`[${DATA_ATTRIBUTE_VIEW_TRACKING}]`);
        for (let i = 0; i < viewTrackingTargets.length; i++) {
            const trackingData = this.trackingDataExtractor.extractTrackingData(viewTrackingTargets[i], DATA_ATTRIBUTE_VIEW_TRACKING);
            if (trackingData && this.htmlConditionChecker.isConditionMet(viewTrackingTargets[i])) {
                this.doTrackPageImpression(trackingData);
            }
        }
    }

    private doTrackPageImpression(trackingData: DataContainer) {
        if (o_product.state.isVariationChanged) {
            const eventMergeID = getGlobalEventMergeId();
            if (eventMergeID) {
                submitEventMerge(eventMergeID, trackingData);
            } else {
                submitEvent(trackingData);
            }
        } else {
            submitMerge(trackingData);
        }
    }
}
